import React, { useEffect, useMemo, useState } from "react";
import { buildResultTemplatesManager } from "@coveo/headless";
import MediaContacts from "./MediaContacts";
import generateResultsJSXElements from "components/coveo-headless/controllers/ResultTemplateManager";

const MediaCenterResultList = (props) => {
	const { controller, headlessEngine, uniqueId, templates, showMoreText, resultDescription } =
		props;
	const [state, setState] = useState(controller.state);
	const contactCardGuid = `contactCardData_${uniqueId}`;
	const additionalContent = window[contactCardGuid];
	useEffect(
		() =>
			controller.subscribe(() => {
				setState(controller.state);
			}),
		[controller]
	);
	const resultTemplatesManager = useMemo(
		() => buildResultTemplatesManager(headlessEngine),
		[headlessEngine]
	);
	resultTemplatesManager.registerTemplates(
		...generateResultsJSXElements(templates, headlessEngine)
	);

	if (!state.results.length) {
		return (
			<div className="media-center-result-list">
				{additionalContent ? <MediaContacts additionalContent={additionalContent} /> : ""}
				<div className="media-center-result-list-count">
					<h4 className="media-center-result-list-count-items">
						{headlessEngine.state.search.response.totalCount} {resultDescription}
					</h4>
				</div>
			</div>
		);
	}

	return (
		<div className="media-center-result-list">
			{additionalContent ? <MediaContacts additionalContent={additionalContent} /> : ""}
			<div className="media-center-result-list-count">
				<h4 className="media-center-result-list-count-items">
					{headlessEngine.state.search.response.totalCount} {resultDescription}
				</h4>
			</div>
			{state.results.map((result) => {
				const template = resultTemplatesManager.selectTemplate(result);

				if (!template) throw new Error(`No result template provided for ${result.title}.`);

				return template(result);
			})}

			{state.moreResultsAvailable ? (
				<div className="media-center-result-list-btn-container">
					<button
						className="media-center-result-list-btn t-label-sm-heavy"
						onClick={() => controller.fetchMoreResults()}
					>
						{showMoreText}
					</button>
				</div>
			) : null}
		</div>
	);
};

export default MediaCenterResultList;
